import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { getLining } from '../../../helpers/lining';
import { mapOptionsOrder } from '../../../helpers/optionsSort';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import {
  Selector,
  SelectorImageItem,
  SelectorItem,
} from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  lining: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (transparency, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      transparency,
    },
  });

export const Transparency = () => {
  const [state, send] = useService(productBuilderMachine);
  const { transparency } = state.context.custom;
  const productType = getBaseProductType(state.context);
  const liningOptions = getLining(state.context);

  if (isCurrentState('transparency', state) && liningOptions.length === 0) {
    throwError(state);
  }

  // const liningTypesOrder = ['Blockout', 'Light Filter', 'Unlined'];
  const liningTypesOrder = ['Blockout', 'In-between/Dim Out', 'Semi-Transparent', 'Semi-transparent', 'Sheer'];
  let sortedLiningTypes = mapOptionsOrder(liningOptions, liningTypesOrder);

  return (
    <SectionContent>
      <Heading>Transparency</Heading>
      <Selector isSlider={true}>
        {sortedLiningTypes.map(option => {
          const isSelected = option === transparency;
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'transparency',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={isSelected}
              onClick={onClick(option, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              key={option}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
